export default __webpack_public_path__ + "static/media/budgit.8ba7c7d1.png";